var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM9.79 16.29L6.2 12.7C6.10742 12.6074 6.03398 12.4975 5.98387 12.3765C5.93377 12.2556 5.90798 12.1259 5.90798 11.995C5.90798 11.8641 5.93377 11.7344 5.98387 11.6135C6.03398 11.4925 6.10742 11.3826 6.2 11.29C6.29258 11.1974 6.40249 11.124 6.52346 11.0739C6.64442 11.0238 6.77407 10.998 6.905 10.998C7.03593 10.998 7.16558 11.0238 7.28654 11.0739C7.40751 11.124 7.51742 11.1974 7.61 11.29L10.5 14.17L17.38 7.29C17.567 7.10302 17.8206 6.99798 18.085 6.99798C18.3494 6.99798 18.603 7.10302 18.79 7.29C18.977 7.47698 19.082 7.73057 19.082 7.995C19.082 8.25943 18.977 8.51302 18.79 8.7L11.2 16.29C11.1075 16.3827 10.9976 16.4563 10.8766 16.5064C10.7557 16.5566 10.626 16.5824 10.495 16.5824C10.364 16.5824 10.2343 16.5566 10.1134 16.5064C9.9924 16.4563 9.88251 16.3827 9.79 16.29Z",
    fill: "#2AA14C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.4cc38b7de9c9af7ca3596dee61cdaa4f.svg";
export { ForwardRef as ReactComponent };